const devices = [{
  regex: /(iPhone|iPod)/i,
  type: 'phone'
}, {
  regex: /iPad/i,
  type: 'tablet'
}, {
  regex: /(?=.*\bAndroid\b)(?=.*\bMobile\b)/i,
  type: 'phone'
}, {
  regex: /Android/i,
  type: 'tablet'
}, {
  regex: /Windows Phone/i,
  type: 'phone'
}, {
  regex: /(?=.*\bWindows\b)(?=.*\bARM\b)/i,
  type: 'tablet'
}, {
  regex: /(BlackBerry|BB10)/i,
  type: 'phone'
}, {
  regex: /Opera Mini/i,
  type: 'phone'
}, {
  regex: /(CriOS|Chrome)(?=.*\bMobile\b)/i,
  type: 'phone'
}, {
  regex: /(?=.*\bFirefox\b)(?=.*\bMobile\b)/i,
  type: 'phone'
}];

/**
 * Функция для получения типа устройства из UserAgent-строки
 */
export function uaToDeviceType(userAgent) {
  if (userAgent) {
    for (let i = 0; i < devices.length; i++) {
      const device = devices[i];
      if (device.regex.test(userAgent)) {
        return device.type;
      }
    }
  }
  return 'desktop';
}